<template>
  <div class="col-md-8">
    <div class="form-group">
      <div my-15px>
        <label class="mx-5">
          <h5>
            Picture
            <span class="small light">
              Recommended size 300 x 300 px / less than 1 MB
            </span>
          </h5>
        </label>

        <div class="form-group">
          <div class="d-block wrapper-image-preview">
            <img
              v-if="picture"
              :src="picture"
              class="img img-fluid image-preview"
            />
          </div>
          <input
            type="file"
            ref="picture"
            accept="image/*"
            class="form-control"
            @change="uploadImage"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { prizeService } from "@/api/client";

export default {
  name: "PrizePicture",

  props: ["lot"],

  data() {
    return {
      file: null,
    };
  },

  computed: {
    picture() {
      return this.lot.picture;
    },

    disabled() {
      return this.lot.status != "draft";
    },
  },

  methods: {
    async uploadImage(event) {
      const file = event.target.files[0];

      if (!file) return;

      if (file.size > 1000000) {
        await this.$dialogs.alert("File shall not exceed 1 MB");
        event.target.files[0].value = "";
        return;
      }

      try {
        const form = new FormData();

        form.append("picture", file);

        const { id } = this.lot;

        await prizeService.uploadPicture(id, form);

        this.$emit("updated");
        this.$notify(`Prize picture updated.`);
      } catch (error) {
        console.error(error);
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Upload picture error.`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.light {
  color: gray;
  font-weight: 300;
}

.wrapper-image-preview {
  text-align: center;
  width: 420px;
  min-height: 300px;
  background-color: #efefef;
}

.image-preview {
  padding: 12px;
  width: 420px;
  min-height: 300px;
  background-color: #eaeaea;
}

.image-preview,
input[type="file"] {
  width: 420px;
  max-height: 300px;
}
</style>
